export default {
      id: "icon-banane-usage",
      viewBox: "0 0 118.1 111.9",
      url: __webpack_public_path__ + "icons.svg#icon-banane",
      toString: function () {
        return this.url;
      }
    }